import { render } from "./CalendarPreviousIcon.vue?vue&type=template&id=44e7ce53"
import script from "./CalendarPreviousIcon.vue?vue&type=script&lang=js"
export * from "./CalendarPreviousIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__